export interface LanguageCatalogEntry {
    code: string;
    language: string;
}

export const LANGUAGE_CATALOG: LanguageCatalogEntry[] = [
    { code: 'ar', language: 'Arabic' },
    { code: 'hy', language: 'Armenian' },
    { code: 'az', language: 'Azerbaijani' },
    { code: 'eu', language: 'Basque' },
    { code: 'be', language: 'Belarusian' },
    { code: 'bn', language: 'Bengali' },
    { code: 'bs', language: 'Bosnian' },
    { code: 'br', language: 'Breton' },
    { code: 'bg', language: 'Bulgarian' },
    { code: 'ca', language: 'Catalan' },
    { code: 'ce', language: 'Chechen' },
    { code: 'zh', language: 'Chinese' },
    { code: 'hr', language: 'Croatian' },
    { code: 'cs', language: 'Czech' },
    { code: 'da', language: 'Danish' },
    { code: 'nl', language: 'Dutch (Standard)' },
    { code: 'en', language: 'English' },
    { code: 'et', language: 'Estonian' },
    { code: 'fa', language: 'Farsi' },
    { code: 'fi', language: 'Finnish' },
    { code: 'fr', language: 'French (Standard)' },
    { code: 'fy', language: 'Frisian' },
    { code: 'fur', language: 'Friulian' },
    { code: 'gd', language: 'Gaelic (Scots)' },
    { code: 'gd-IE', language: 'Gaelic (Irish)' },
    { code: 'ka', language: 'Georgian' },
    { code: 'de', language: 'German (Standard)' },
    { code: 'el', language: 'Greek' },
    { code: 'he', language: 'Hebrew' },
    { code: 'hi', language: 'Hindi' },
    { code: 'hu', language: 'Hungarian' },
    { code: 'is', language: 'Icelandic' },
    { code: 'id', language: 'Indonesian' },
    { code: 'ga', language: 'Irish' },
    { code: 'it', language: 'Italian (Standard)' },
    { code: 'ja', language: 'Japanese' },
    { code: 'ko', language: 'Korean' },
    { code: 'lv', language: 'Latvian' },
    { code: 'lt', language: 'Lithuanian' },
    { code: 'mk', language: 'FYRO Macedonian' },
    { code: 'ms', language: 'Malay' },
    { code: 'no', language: 'Norwegian' },
    { code: 'pl', language: 'Polish' },
    { code: 'pt', language: 'Portuguese' },
    { code: 'pt-BR', language: 'Portuguese (Brazil)' },
    { code: 'pa', language: 'Punjabi' },
    { code: 'ro', language: 'Romanian' },
    { code: 'ru', language: 'Russian' },
    { code: 'sr', language: 'Serbian' },
    { code: 'sk', language: 'Slovak' },
    { code: 'sl', language: 'Slovenian' },
    { code: 'es', language: 'Spanish' },
    { code: 'sw', language: 'Swahili' },
    { code: 'sv', language: 'Swedish' },
    { code: 'th', language: 'Thai' },
    { code: 'tr', language: 'Turkish' },
    { code: 'tk', language: 'Turkmen' },
    { code: 'uk', language: 'Ukrainian' },
    { code: 'ur', language: 'Urdu' },
    { code: 've', language: 'Venda' },
    { code: 'vi', language: 'Vietnamese' }
];
